import { createCustomEnum } from "./customEnum";

const Sponsors = createCustomEnum({
	USBank: {
		value: 23,
		name: "USBank",
		displayName: "US Bank",
	},
	Esquire: {
		value: 24,
		name: "Esquire",
		displayName: "Esquire (prev. BBVA)",
	},
	Evolve: {
		value: 2,
		name: "Evolve",
		displayName: "Evolve",
	},
	Merrick: {
		value: 3,
		name: "Merrick",
		displayName: "Merrick",
	},
	WellsRetail: {
		value: 8,
		name: "WellsRetail",
		displayName: "Wells Retail",
	},
	FiservCanada: {
		value: 9,
		name: "FiservCanada",
		displayName: "Fiserv Canada",
	},
	LegacySponsor: {
		value: 22,
		name: "LegacySponsor",
		displayName: "Evo",
	},
});

export default Sponsors;
